import React, { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import Spinner from '../../layout/Spinner';
import { authRoute, localToken } from '../../utils/constants';

const ShowPageAdsVolume = (props) => {
  const { accountId, pageId, userToken } = props;
  const [adsVolume, setAdsVolume] = useState(null);
  useEffect(() => {
    try {
      axios
        .post(
          `${authRoute}/accountDashboard/getAdVolumeForPage`,
          { accountId, pageId, userToken },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Baerer ${localToken}`,
            },
          }
        )
        .then((res) => {
          setAdsVolume(res.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);
  return !adsVolume ? (
    <Spinner />
  ) : (
    <div>
      <span>{adsVolume?.error?.error ? <>{adsVolume.error.error.message}</> : null}</span>
      <span>{Array.isArray(adsVolume?.data) ? adsVolume?.data[0]?.ads_running_or_in_review_count : null}</span>
    </div>
  );
};

export default ShowPageAdsVolume;
